import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CardIcon = props => {
  return (
    <Svg
      width={22}
      height={15}
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.184.412L11 .25 3.816.412a2.809 2.809 0 00-2.699 2.3 26.485 26.485 0 000 9.575 2.809 2.809 0 002.7 2.3L11 14.75l7.184-.162a2.809 2.809 0 002.699-2.3c.582-3.166.582-6.41 0-9.575a2.809 2.809 0 00-2.7-2.3zM3.85 1.912L11 1.75l7.15.162c.62.014 1.145.461 1.258 1.072.153.834.263 1.674.33 2.516H2.262c.068-.842.178-1.682.332-2.516A1.309 1.309 0 013.85 1.912zM2.181 7.5c0 1.512.137 3.023.412 4.516.112.61.637 1.058 1.257 1.072l7.15.162 7.15-.162a1.309 1.309 0 001.258-1.072c.274-1.493.411-3.004.411-4.516H2.181z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default CardIcon;
